import { combineReducers } from 'redux';

import { ADBLOCKER_DETECTED, COOKIES_ENABLED } from './constants';

const adBlockerDetected = (state = null, action) => {
    switch (action.type) {
        case ADBLOCKER_DETECTED:
            return action.isDetected;
        default:
            return state;
    }
};

const cookiesEnabled = (state = null, action) => {
    switch (action.type) {
        case COOKIES_ENABLED:
            return action.isEnabled;
        default:
            return state;
    }
};

export default combineReducers({ adBlockerDetected, cookiesEnabled });



// WEBPACK FOOTER //
// ./src/services/adblocker/reducer.js